import React from "react";

function Header() {
    return <header>
        <h1>Histogram Component (React and D3)</h1>
    </header>
}

export default Header